import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { knowledgeApi, type KnowledgeArticle } from '../../api/knowledge';

export function KnowledgeEditorPage() {
  const [articles, setArticles] = useState<KnowledgeArticle[]>([]);
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [error, setError] = useState('');

  const load = () => {
    void knowledgeApi.listArticles().then(setArticles).catch((e) => setError(String(e)));
  };

  useEffect(() => { load(); }, []);

  const create = async () => {
    if (!title.trim() || !content.trim()) return;
    try {
      await knowledgeApi.createArticle({ title, content, category: 'general' });
      setTitle(''); setContent('');
      load();
    } catch (e) {
      setError(String(e));
    }
  };

  return (
    <div className="mx-auto max-w-4xl p-6">
      <Link to="/knowledge" className="text-sm text-slate-600 hover:underline dark:text-slate-400">← Knowledge Center</Link>
      <h1 className="mt-2 text-2xl font-semibold">Knowledge Editor</h1>
      <div className="mt-6 space-y-3">
        <input value={title} onChange={(e) => setTitle(e.target.value)} placeholder="Article title"
          className="w-full rounded border px-3 py-2 dark:border-slate-600 dark:bg-slate-900" />
        <textarea value={content} onChange={(e) => setContent(e.target.value)} placeholder="Article content" rows={5}
          className="w-full rounded border px-3 py-2 dark:border-slate-600 dark:bg-slate-900" />
        <button onClick={() => void create()}
          className="rounded bg-slate-900 px-4 py-2 text-white dark:bg-slate-100 dark:text-slate-900">
          Publish Article
        </button>
      </div>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <ul className="mt-6 space-y-3">
        {articles.map((a) => (
          <li key={a.id} className="rounded-lg border p-4 dark:border-slate-700">
            <div className="flex justify-between">
              <span className="font-medium">{a.title}</span>
              <span className="text-xs text-slate-500">{a.status} · v{a.version}</span>
            </div>
            <p className="mt-1 text-sm text-slate-500 line-clamp-2">{a.content}</p>
          </li>
        ))}
      </ul>
    </div>
  );
}
